import { UserLocale } from '@mnd-frontend/graphql-schema';

export const urls = (userLocale: UserLocale) => ({
  get accessibilityStatement() {
    switch (userLocale) {
      case UserLocale.Sv:
        return 'https://www.mynewsdesk.com/se/about/terms-and-conditions/accessibility_statement';
      default:
        // Default to English
        return 'https://www.mynewsdesk.com/about/terms-and-conditions/accessibility_statement';
    }
  },
});
